module.exports = {
  rules: {
    // Equality
    equals: require('./equals'),

    // Numeric
    lesser: require('./lesser'),
    lesserOrEqual: require('./lesser-or-equal'),
    between: require('./between'),
    greaterOrEqual: require('./greater-or-equal'),
    greater: require('./greater'),

    // Sets
    has: require('./has'),
    hasAll: require('./has-all'),
    hasAny: require('./has-any'),
    hasExact: require('./has-exact'),
    subsetOf: require('./subset-of'),

    // Strings
    substring: require('./substring'),
    startsWith: require('./starts-with'),
    endsWith: require('./ends-with'),
    regex: require('./regex'),
    
    // Generalized splitting
    idList: require('./id-list'),
    idPercentage: require('./id-percentage'),

    // GoDaddy Identifiers
    locale: require('./locale'),
    shopperList: require('./shopper-list'),
    shopperPercentage: require('./shopper-percentage'),
    threeLetter: require('./three-letter'),
    reseller: require('./reseller'),
  }
};
